import { Row, Col, Pagination } from "react-bootstrap";
import BTable from "react-bootstrap/Table";
import {
    useTable,
    useSortBy,
    usePagination,
    useGlobalFilter,
} from "react-table";
import { useNavigate } from "react-router-dom";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { useEffect, useState } from "react";
import { right } from "../../assets/img";

export function Table({
    columns,
    data,
    tableHeight,
    setPageno,
    pagecount,
    show,
    pageno,
    color = "#000",
}) {
    const navigate = useNavigate();
    const [pagenumber, setPagenumber] = useState(1);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        gotoPage,
        pageCount,
        state: { pageIndex },
    } = useTable(
        {
            columns,
            data,
            initialState: { pageIndex: pageno ? pageno - 1 : 0, pageSize: 20 },
        },
        useGlobalFilter,
        useSortBy,
        usePagination
    );

    useEffect(() => {
        setPagenumber(pageIndex + 1);
    }, [pageIndex]);

    return (
        <div style={{ marginBottom: 40 }} className="table-design">
            <BTable
                size="sm"
                responsive
                bordered
                {...getTableProps()}
                className="custom-table mb-0"
            >
                <style>
                    {`
.table-responsive {
    height: ${tableHeight ? tableHeight : 'null'}; /// calc(100vh - 350px)
    overflow-y: auto;
    overflow-x: auto;
     padding-left: 10px;
    padding-right: 10px;
}

.custom-table {
    border: 2px solid #d8d8d8 !important;
    border-collapse: collapse !important;
    width: 100%;
    background-color: #fff !important;
}

.custom-table th,
.custom-table td {
    border: 2px solid #d8d8d8 !important;
    text-align: left;
    vertical-align: middle;
    padding: 0px 4px !important;
    line-height: 1.3 !important;
}

/* Header background */
.custom-table thead th {
    background-color: #F0EDE6 !important;
    position: sticky;
    top: -1px;
}

/* ------------------------------
   SIMPLE ALTERNATING ROW COLORS
   Row 1: White
   Row 2: #F0EDE6
   Row 3: White
   Row 4: #F0EDE6
-------------------------------- */
.custom-table tbody tr:nth-child(odd) {
    background-color: #ffffff !important;
}
.custom-table tbody tr:nth-child(even) {
    background-color: #F0EDE6 !important;
}

/* Hover */
.custom-table tbody tr:hover {
    background-color: #e6e2d8 !important;
}
`}
                </style>

                <thead>
                    {headerGroups.map((headerGroup, ind) => (
                        <tr {...headerGroup.getHeaderGroupProps()} key={ind}>
                            {headerGroup.headers.map((column, indx) => (
                                <th
                                    className="px-2 text-center"
                                    {...column.getHeaderProps(column.getSortByToggleProps())}
                                    key={indx}
                                    style={{
                                        verticalAlign: "middle",
                                        textAlign: "left",
                                    }}
                                >
                                    <h4 className="f3 fs-xs-14 fs-sm-12 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18 py-1 primary">
                                        {column.render("Header")}
                                    </h4>
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>

                <tbody {...getTableBodyProps()}>
                    {page.length === 0 ? (
                        <tr>
                            <td
                                colSpan={columns.length}
                                className="text-center py-3"
                                style={{
                                    color: "#666",
                                    fontWeight: "600",
                                    backgroundColor: "#F0EDE6",
                                    fontSize: "14px",
                                }}
                            >
                                No data
                            </td>
                        </tr>
                    ) : (
                        page.map((row, i) => {
                            prepareRow(row);
                            return (
                                <tr className="f2" {...row.getRowProps()} key={i}>
                                    {row.cells.map((cell, ind) => (
                                        <td
                                            {...cell.getCellProps()}
                                            key={ind}
                                            style={{
                                                color: color,
                                                textAlign: "left",
                                                verticalAlign: "middle",
                                                backgroundColor: i % 2 === 0 ? "#ffffff" : "#F0EDE6",   // ✅ add this
                                            }}
                                            className="fs-xs-14 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20 px-2 py-1 gray2 list-data"
                                        >
                                            {cell.render("Cell")}
                                        </td>
                                    ))}
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </BTable>

            {show && (
                <Row className="justify-content-between table-show p-2 w-100 bg-primary2">
                    <Col className="d-flex ac-jb">
                        <p className="px-1 mb-0 f3">Total Pages {pageCount}</p>
                        <Pagination className="gap-1 pointer mb-0 d-flex ac-js">
                            {pagenumber > 1 && (
                                <PlayArrowIcon
                                    className="left-arrow"
                                    onClick={() =>
                                        setPagenumber((prev) => (prev > 1 ? prev - 1 : 1))
                                    }
                                />
                            )}

                            <input
                                type="number"
                                style={{ width: "40px", height: "30px" }}
                                className="form-control1 ml-2 p-1 py-1 text-center"
                                value={pagenumber}
                                onFocus={(e) => e.target.select()}
                                onChange={(e) => {
                                    if (!Number(e.target.value)) {
                                        setPagenumber(e.target.value);
                                        return;
                                    }
                                    if (e.target.value > pageCount) {
                                        gotoPage(pageCount - 1);
                                        setPagenumber(pageCount);
                                        return;
                                    }
                                    const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                    gotoPage(page);
                                    setPagenumber(e.target.value);
                                }}
                            />


                            <img src={right} width={30} height={30} alt="" />
                            <PlayArrowIcon
                                className="right-arrow"
                                onClick={() =>
                                    setPagenumber((prev) =>
                                        prev < pageCount ? prev + 1 : prev
                                    )
                                }
                            />
                        </Pagination>
                    </Col>
                </Row>
            )}
        </div>
    );
}
